module.exports = __webpack_public_path__ + "img/3_uk.ba070217.svg";